import Logo from 'components/Logo';
import { DrawerContainer, LogoContainer, StyledDrawer } from './ProcessManagementSidebar.styles';

interface ProcessManagementSidebarProps {
  isOpen: boolean;
}


const ProcessManagementSidebar = ({ isOpen }: ProcessManagementSidebarProps) => (
  <StyledDrawer
    anchor="left"
    open={isOpen}
    variant="permanent"
    $isOpen={isOpen}
  >
    <DrawerContainer>
      <LogoContainer>
        <Logo variation="small" />
      </LogoContainer>
    </DrawerContainer>
  </StyledDrawer>
);


export default ProcessManagementSidebar; 